import React from 'react';
import { Star } from 'lucide-react';

export const RatingStars = ({ rating = 0, maxRating = 5, size = "sm", showValue = true }) => {
  // Ensure rating is a valid number
  const validRating =
    isNaN(rating) || rating === null || rating === undefined
      ? 0
      : Number(rating);

  const stars = [];
  const fullStars = Math.floor(validRating);
  const hasHalfStar = validRating % 1 !== 0;

  const sizeClasses = {
    xs: "h-2.5 w-2.5",
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };

  const iconSize = sizeClasses[size] || sizeClasses.sm;

  for (let i = 0; i < maxRating; i++) {
    if (i < fullStars) {
      // Full star
      stars.push(
        <Star
          key={i}
          className={`${iconSize} fill-yellow-400 text-yellow-400`}
        />
      );
    } else if (i === fullStars && hasHalfStar) {
      // Half star
      stars.push(
        <div key={i} className={`${iconSize} relative`}>
          <Star className={`${iconSize} text-slate-300 dark:text-slate-600`} />
          <div className="absolute inset-0 overflow-hidden w-1/2">
            <Star className={`${iconSize} fill-yellow-400 text-yellow-400`} />
          </div>
        </div>
      );
    } else {
      // Empty star
      stars.push(
        <Star
          key={i}
          className={`${iconSize} text-slate-300 dark:text-slate-600`}
        />
      );
    }
  }

  const spacingClass = size === "xs" ? "space-x-0.5" : "space-x-1";

  return (
    <div className={`flex items-center ${spacingClass}`}>
      <div className="flex">{stars}</div>
      {showValue && (
        <span
          className={`text-slate-600 dark:text-slate-400 ml-1 ${
            size === "xs" ? "text-xs" : "text-xs"
          }`}
        >
          {isNaN(validRating) ? "0.0" : validRating.toFixed(1)}
        </span>
      )}
    </div>
  );
}; 